import $ from "jquery"
import "slick-carousel-latest"

var $slickParallaxElement = $('.js-parallax-thumbnail-slider');
var $sliderParent = $slickParallaxElement.parent();

$('.js-parallax-main-item-matchheight').matchHeight();

$slickParallaxElement.slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.js-parallax-main-slider',
    dots: false,
    arrows: true,
    vertical: true,
    focusOnSelect: true,
    verticalSwiping: false,
    swipe: false,
    swipeToSlide: false,
    responsive: [
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
                vertical: false,
            }
        },
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                vertical: false,
                arrows: false,
                dots: true,
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                vertical: false,
                arrows: true,
                dots: true,
                centerMode: true,
                centerPadding: '75px',
            }
        }
    ]
});


$slickParallaxElement.on('afterChange', function(event, slick, currentSlide){
    $sliderParent.find('.js-parallax-counter .js-parallax-counter-active').html(currentSlide + 1);
    history.pushState({}, '',  '#' + $('.js-parallax-thumbnail-slider .slick-slide.slick-active .parallax__thumbnail-item').data('anchor'));
});

var sliderItemsNum = $slickParallaxElement.find('.slick-slide').not('.slick-cloned').length;
$sliderParent.find('.js-parallax-counter .js-parallax-counter-total').html(sliderItemsNum);

$('.js-parallax-main-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    asNavFor: '.js-parallax-thumbnail-slider',
    dots: false,
    arrows: false,
    fade: true,
    cssEase: 'linear',
    swipe: false,
    swipeToSlide: false,
});
